<template>
  <b-card no-body>
    <template v-slot:header>
      <h2 class="mb-0">
        <template v-if="innerItem.id">Редактирование новости #{{ innerItem.id }}</template>
        <template v-else>Добавление новости</template>
      </h2>
    </template>

    <div class="block" v-if="Object.keys($page.props.errors).length > 0">
      <b-alert class="mb-0" variant="danger" :show="Object.keys($page.props.errors).length > 0">
        <h4 class="alert-heading">Исправьте ошибки и попробуйте сохранить снова</h4>
        <ul class="list-unstyled mb-0">
          <template v-for="(errors, name) in $page.props.errors">
            <li v-for="(error, i) in errors" :key="name+i">
              {{ error }}
            </li>
          </template>
        </ul>
      </b-alert>
    </div>

    <b-form @submit.prevent="onSubmit">
      <div class="block bg-galsen">
        <b-form-row>
          <div class="col">
            <b-form-group label="Дата" :invalid-feedback="fieldError('created_at')" :state="fieldState('created_at')">
              <masked-input mask="11.11.1111" type="text"
                            required
                            v-model="innerItem.created_at"
                            class="form-control" placeholder="Дата"></masked-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Статус">
              <b-select v-model="innerItem.is_published" :invalid-feedback="fieldError('is_published')" :state="fieldState('is_published')">
                <b-select-option :value="false">Не опубликовано</b-select-option>
                <b-select-option :value="true">Опубликовано</b-select-option>
              </b-select>
            </b-form-group>
          </div>
        </b-form-row>
      </div>

      <div class="block">
        <b-form-group label="Заголовок" :invalid-feedback="fieldError('title')">
          <b-input required v-model="innerItem.title"
                   :state="fieldState('title')"></b-input>
        </b-form-group>
      </div>

      <div class="block bg-galsen">
        <b-form-group label="Обложка" :invalid-feedback="fieldError('cover')">
          <b-file v-model="innerItem.cover" browse-text="Выбрать" placeholder="Файл не выбран"
                  accept="image/*"
                  :state="fieldState('cover')"></b-file>
        </b-form-group>

        <b-img v-if="hasImage" :src="imgSrc" class="mt-3 mb-3" thumbnail fluid block></b-img>
        <b-img v-if="innerItem && innerItem.current_cover && ! hasImage" :src="innerItem.current_cover" class="mt-3 mb-3" thumbnail fluid block></b-img>
      </div>

      <div class="block">
        <file-manager v-model="showFileManager" type="image" @select="pasteFilePath($event)"></file-manager>

        <b-form-group label="Выдержка" :invalid-feedback="fieldError('excerpt')" :state="fieldState('excerpt')">
          <b-btn size="sm" variant="outline-secondary" @click="showFileManager = true; fileManagerTarget = 'excerptEditor'">Вставить файл</b-btn>
          <br><br>
          <editor v-model="innerItem.excerpt" lang="html" @init="initEditor" width="100%" height="300" ref="excerptEditor"></editor>
        </b-form-group>

        <b-form-group label="Текст" :invalid-feedback="fieldError('content')" :state="fieldState('content')">
          <b-btn size="sm" variant="outline-secondary" @click="showFileManager = true; fileManagerTarget = 'contentEditor'">Вставить файл</b-btn>
          <br><br>
          <editor v-model="innerItem.content" lang="html" @init="initEditor" width="100%" height="300" ref="contentEditor"></editor>
        </b-form-group>

        <div class="text-right mt-3">
          <b-btn :disabled="! item.can.delete" @click="onDelete()" v-if="innerItem.id"
                 variant="outline-light" class="text-danger mr-3">Удалить</b-btn>
          <b-btn-group>
            <b-btn :disabled="innerItem.id ? ! item.can.update : ! $page.props.can.news['create']"
                   @click="onSubmit($event)"
                   size="lg" variant="outline-primary">Применить</b-btn>
            <b-btn :disabled="innerItem.id ? ! item.can.update : ! $page.props.can.news['create']"
                   @click="onSubmit($event, true)"
                   size="lg" variant="outline-primary">Сохранить и закрыть</b-btn>
          </b-btn-group>
        </div>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import MaskedInput from 'vue-masked-input'
import FileManager from '~/Components/FileManager/FileManager'

const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export default {
  components: {
    MaskedInput,
    editor: require('vue2-ace-editor'),
    FileManager
  },
  props: {
    item: Object
  },
  remember: 'innerItem',
  data () {
    return {
      showFileManager: false,
      fileManagerTarget: null,
      innerItem: {
        id: null,
        created_at: new Date().toJSON().slice(0, 10).split('-').reverse().join('.'),
        is_published: false,
        title: '',
        excerpt: '',
        content: '',
        cover: null
      },
      imgSrc: null
    }
  },

  created () {
    if (this.item) {
      this.innerItem = { ...this.item }
    }
  },

  methods: {
    initEditor () {
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/theme/chrome')
    },

    onSubmit (event, redirectToList = false) {
      if (Number.isInteger(this.innerItem.id)) {
        const route = this.route('backend.news.update', {
          news: this.innerItem.id,
          ...(redirectToList && { redirectToList: true })
        })

        this.$inertia.post(route, { ...this.innerItem, _method: 'PUT' })
        return
      }

      const route = this.route('backend.news.store', { ...(redirectToList && { redirectToList: true }) })
      this.$inertia.post(route, this.innerItem)
    },

    onDelete () {
      if (!confirm('Вы уверены?')) {
        return
      }

      this.$inertia.delete(this.route('backend.news.destroy', this.innerItem.id))
    },

    pasteFilePath (event) {
      this.$refs[this.fileManagerTarget].editor.insert(event)
    }
  },
  computed: {
    hasImage () {
      return !!this.innerItem.cover
    }
  },
  watch: {
    'innerItem.cover' (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSrc = value
            })
            .catch(() => {
              this.imgSrc = null
            })
        } else {
          this.imgSrc = null
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.block {
  padding: 20px;
}
</style>
